// extracted by mini-css-extract-plugin
export default {"print":"PrintComponent_print__6ySvL"};